/**
 * Fix FC (2026-10-06): "En ambos partes diarios por favor, se le puede agregar filtro por
 * turno y filtro por obra, aparte del filtro por empleado" (CEN). El turno y la obra son
 * los del legajo del empleado. Sin empleados elegidos, se cargan todos los del filtro.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../contexts/AuthContext";

export function useTurnos() {
  const [turnos, setTurnos] = useState([]);
  useEffect(() => {
    axios.get(`${API}/hr/turnos`, { withCredentials: true }).then(r => setTurnos(r.data || [])).catch(() => setTurnos([]));
  }, []);
  return turnos;
}

// Empleados que cumplen el turno y la obra elegidos ("__sin__" = sin turno asignado).
export function filtrarEmpleados(workers, turnoId, projectId) {
  return (workers || []).filter(w =>
    (!turnoId || (turnoId === "__sin__" ? !w.turno_id : w.turno_id === turnoId))
    && (!projectId || w.project_id === projectId));
}

// Los ids a cargar: los elegidos que cumplen el filtro; sin elegir, los activos del filtro.
export function idsACargar(workers, elegidos, turnoId, projectId) {
  const visibles = filtrarEmpleados(workers, turnoId, projectId);
  const ids = visibles.map(w => w.id || w._id);
  if ((elegidos || []).length) return elegidos.filter(id => ids.includes(id));
  if (!turnoId && !projectId) return [];
  return visibles.filter(w => w.status !== "inactivo").map(w => w.id || w._id);
}

export function SelectTurno({ turnos, value, onChange, className, testid }) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)} className={className} data-testid={testid}>
      <option value="">Todos los turnos</option>
      {(turnos || []).map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
      <option value="__sin__">Sin turno asignado</option>
    </select>
  );
}
